import { Fragment } from "react";
import React from "react";
import {
  Transition,
} from "@headlessui/react";
import {Navigate } from "react-router-dom";
import {
  XIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
} from "@heroicons/react/solid";
import axios from "axios";


class Organizationprofile extends React.Component {
  constructor(props) {
    super(props);
    this.saveItem = this.saveItem.bind(this);
    this.image = React.createRef();
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      success: false,
      redirect: false,
      name: "",
      street_one: "",
      street_two: "",
      city: "",
      stateList: [],
      state_union_territory_id: "",
      zip_postal_code: "",
      phone: "",
      fax: null,
      website: "",
      gstin: "",
      imageURL: "",
      image: "",
      error_list: [],
      loader_status: false,
      try_again_status: false,
      main_content_status: false,
    };
  }

  setLoaderFunction = () => {

    this.setState({
      loader_status: true,
      try_again_status: false,
      main_content_status: false,
    });
  };
  closeLoaderFuncion = () => {
    this.setState({
      loader_status: false,
      try_again_status: false,
      main_content_status: true,
    });
  };

  enableTryAgain = () => {

    this.setState({
      loader_status: false,
      try_again_status: true,
      main_content_status: false,
    });
  };

  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    this.setState({ sidebarOpen: true });
  };

  componentDidMount() {
    this.getDataForView();
  }


  async getDataForView() {
    try {
      this.setLoaderFunction()
      const token = localStorage.getItem("token");
      const id = this.props.leadId
      const [
        { data: profile },
        { data: state },
      ] = await Promise.all([
        axios.get("api/organization/profile", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
        axios.get("api/states/" + 101, { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } })
      ]);
      this.setState({ name: profile.organization_profile.name });
      this.setState({ street_one: profile.organization_profile.street_one });
      this.setState({ street_two: profile.organization_profile.street_two });
      this.setState({ city: profile.organization_profile.city });
      this.setState({ state_union_territory_id: profile.organization_profile.state_union_territory_id });
      this.setState({ zip_postal_code: profile.organization_profile.zip_postal_code });
      this.setState({ phone: profile.organization_profile.phone });
      this.setState({ website: profile.organization_profile.website });
      this.setState({ gstin: profile.organization_profile.gstin });
      this.setState({ imageURL: profile.organization_profile.image_url });
      this.setState({ stateList: state.states });
      this.closeLoaderFuncion();
    } catch (error) {
      console.error("Error fetching data: ", error);
      this.enableTryAgain()
    }
  }



  tryAgain = () => {

    this.getDataForView()

  }



  handleInput = (e) => {
    var token = localStorage.getItem("token");

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  saveItem = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("image", this.image.current.files[0]);
    formData.append("name", this.state.name);
    formData.append("street_one", this.state.street_one);
    formData.append("street_two", this.state.street_two);
    formData.append("city", this.state.city)
    formData.append("state_union_territory_id", this.state.state_union_territory_id);
    formData.append("zip_postal_code", this.state.zip_postal_code);
    formData.append("phone", this.state.phone);
    formData.append("website", this.state.website);
    formData.append("fax", this.state.fax);
    formData.append("gstin", this.state.gstin);


    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      "api/organization/profile/update",
      formData,
      { headers }
    );

    if (res.data.success) {
      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    if (res.data.success) {
      localStorage.removeItem("token");
      this.setState({ logoutRedirect: true });
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      window.location.reload(true);
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div>


          {this.state.loader_status && (
            <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
              <div className="bg-white p-4 rounded-md">
                <div className="flex items-center justify-center">
                  <div
                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                </div>
                <p className="text-center mt-4">Loading...</p>
              </div>
            </div>
          )}
          {/*loader_status------------------------------------------------------------------------*/}

          {/*try_again_status-----------------------------------------------------------------------------*/}
          {this.state.try_again_status && (
            <div className="h-screen flex items-center justify-center bg-white ">
              <div className="flex flex-col items-center justify-center h-full">
                <p className="text-red-500">{this.state.error_customize}</p>
                <button
                  type="button"
                  onClick={this.tryAgain}
                  className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  TryAgain
                </button>
              </div>
            </div>
          )}
          {/*try_again_status-----------------------------------------------------------------------------*/}

          {this.state.main_content_status && (

            <div className="flex flex-col flex-1">


              <main className="flex-1 ">
                <div className="py-6">
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                    <h1 className="text-2xl font-semibold text-gray-900">
                      Organization Profile Update
                    </h1>
                  </div>
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                    {/* Replace with your content */}

                    <div className="hidden sm:block" aria-hidden="true">
                      <div className="py-5">
                        <div className="border-t border-gray-200" />
                      </div>
                    </div>
                    <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                      <div className="md:grid md:gap-6">
                        <div className="mt-5 md:mt-0 md:col-span-2">
                          <form onSubmit={this.saveItem}>
                            <div className="shadow overflow-hidden sm:rounded-md">
                              <div className="px-4 py-5 bg-white sm:p-6">
                                <div className="grid grid-cols-6 gap-6">
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                    <label
                                      htmlFor="name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Organization Name
                                    </label>
                                    <input
                                      type="text"
                                      name="name"
                                      id="name"
                                      onChange={this.handleInput}
                                      value={this.state.name}
                                      autoComplete="name"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="name-error"
                                    >
                                      {this.state.error_list.name}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                    <label
                                      htmlFor="street_one"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Address street 1
                                    </label>
                                    <input
                                      type="text"
                                      name="street_one"
                                      id="street_one"
                                      onChange={this.handleInput}
                                      value={this.state.street_one}
                                      autoComplete="street_one"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="street_one-error"
                                    >
                                      {this.state.error_list.street_one}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="street_two"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Address street 2
                                    </label>
                                    <input
                                      type="text"
                                      name="street_two"
                                      id="street_two"
                                      onChange={this.handleInput}
                                      value={this.state.street_two}
                                      autoComplete="street_two"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="street_two-error"
                                    >
                                      {this.state.error_list.street_two}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="city"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      City
                                    </label>
                                    <input
                                      type="text"
                                      name="city"
                                      id="city"
                                      onChange={this.handleInput}
                                      value={this.state.city}
                                      autoComplete="city"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="city-error"
                                    >
                                      {this.state.error_list.city}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="street_two"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      State
                                    </label>
                                    <select
                                      id="state_union_territory_id"
                                      name="state_union_territory_id"
                                      onChange={this.handleInput}
                                      value={this.state.state_union_territory_id}
                                      autoComplete="state_union_territory_id"
                                      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    >
                                      <option value="">------</option>
                                      {this.state.stateList.map(
                                        (number,index) => (
                                          <option key={index} value={number.id}>
                                            {number.name}
                                          </option>
                                        )
                                      )}


                                    </select>
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="phone-error"
                                    >
                                      {this.state.error_list.state_union_territory_id}
                                    </p>

                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="phone"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Phone
                                    </label>
                                    <input
                                      type="text"
                                      name="phone"
                                      id="phone"
                                      onChange={this.handleInput}
                                      value={this.state.phone}
                                      autoComplete="phone"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="phone-error"
                                    >
                                      {this.state.error_list.phone}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="website"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Website
                                    </label>
                                    <input
                                      type="text"
                                      name="website"
                                      id="website"
                                      onChange={this.handleInput}
                                      value={this.state.website}
                                      autoComplete="website"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="website-error"
                                    >
                                      {this.state.error_list.website}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="gstin"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      GSTIN
                                    </label>
                                    <input
                                      type="text"
                                      name="gstin"
                                      id="gstin"
                                      onChange={this.handleInput}
                                      value={this.state.gstin}
                                      autoComplete="gstin"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="gstin-error"
                                    >
                                      {this.state.error_list.gstin}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="zip_postal_code"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      PinCode
                                    </label>
                                    <input
                                      type="text"
                                      name="zip_postal_code"
                                      id="zip_postal_code"
                                      onChange={this.handleInput}
                                      value={this.state.zip_postal_code}
                                      autoComplete="zip_postal_code"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="zip_postal_code-error"
                                    >
                                      {this.state.error_list.zip_postal_code}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="image"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Profile Image
                                    </label>
                                    <input
                                      type="file"
                                      name="image"
                                      id="image"
                                      onChange={this.handleInput}
                                      ref={this.image}
                                      autoComplete="image"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="image-error"
                                    >
                                      {this.state.error_list.image}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                    <label
                                      htmlFor="image"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Profile Image
                                    </label>
                                    <img
                                      className="h-16 w-16 rounded-md"
                                      src={this.state.imageURL}
                                      alt=""
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                <button
                                  type="submit"
                                  className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>

                    {/* /End replace */}
                  </div>
                </div>
              </main>
            </div>
          )}
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Updated
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default Organizationprofile;
